export default __webpack_public_path__ + "static/media/esg-47.f9be93c4.jpg";